// extracted by mini-css-extract-plugin
export default {"chromeframe":"chromeframe_jLGHe"};